import type { IconProps } from "~/design-system/types";

export function CartIcon(props: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.8184 9.15996C21.8184 5.97863 19.2397 3.39996 16.0584 3.39996C12.8771 3.3853 10.2877 5.9533 10.2731 9.13463V9.15996"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9636 15.1652H19.9022"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1888 15.1652H12.1275"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0455 28.6527C7.36821 28.6527 6.36954 25.9194 4.42154 18.6967C2.46688 11.4514 6.38821 8.74072 16.0455 8.74072C25.7029 8.74072 29.6242 11.4514 27.6695 18.6967C25.7215 25.9194 24.7229 28.6527 16.0455 28.6527Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AddToCartIcon(props: IconProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.75 11.25H16.25V7.5H20V5H16.25V1.25H13.75V5H10V7.5H13.75M8.75 22.5C7.375 22.5 6.25 23.625 6.25 25C6.25 26.375 7.375 27.5 8.75 27.5C10.125 27.5 11.25 26.375 11.25 25C11.25 23.625 10.125 22.5 8.75 22.5ZM21.25 22.5C19.875 22.5 18.75 23.625 18.75 25C18.75 26.375 19.875 27.5 21.25 27.5C22.625 27.5 23.75 26.375 23.75 25C23.75 23.625 22.625 22.5 21.25 22.5ZM9 18.5V18.375L10.125 16.25H19.375C20.25 16.25 21.125 15.75 21.5 15L26.375 6.25L24.25 5L19.375 13.75H10.625L5.375 2.5H1.25V5H3.75L8.25 14.5L6.5 17.5C6.375 17.875 6.25 18.25 6.25 18.75C6.25 20.125 7.375 21.25 8.75 21.25H23.75V18.75H9.25C9.125 18.75 9 18.625 9 18.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function HeartIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.87187 11.5983C1.79887 8.24832 3.05287 4.41932 6.56987 3.28632C8.41987 2.68932 10.4619 3.04132 11.9999 4.19832C13.4549 3.07332 15.5719 2.69332 17.4199 3.28632C20.9369 4.41932 22.1989 8.24832 21.1269 11.5983C19.4569 16.9083 11.9999 20.9983 11.9999 20.9983C11.9999 20.9983 4.59787 16.9703 2.87187 11.5983Z"
        stroke="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HeartFilledIcon(props: IconProps) {
  return (
    <svg
      width="46"
      height="43"
      viewBox="0 0 46 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M28.3203 5.44349C27.2289 5.44162 26.1521 5.69445 25.1756 6.18188C24.1991 6.66931 23.3498 7.37788 22.6953 8.25124C21.8089 7.0718 20.574 6.20098 19.1654 5.76201C17.7567 5.32304 16.2458 5.33814 14.8462 5.80518C13.4467 6.27223 12.2294 7.16756 11.3667 8.36448C10.504 9.56141 10.0396 10.9993 10.0391 12.4747C10.0391 20.8962 21.7392 27.5451 22.2372 27.824C22.3772 27.9023 22.5349 27.9435 22.6953 27.9435C22.8557 27.9435 23.0135 27.9023 23.1534 27.824C25.3053 26.5636 27.3249 25.0901 29.1818 23.4255C33.2757 19.7409 35.3516 16.0566 35.3516 12.4747C35.3494 10.6106 34.608 8.82339 33.2898 7.50523C31.9717 6.18707 30.1845 5.4456 28.3203 5.44349Z"
        fill="#ED3528"
      />
    </svg>
  );
}

export function FilterIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Filter 2">
        <path
          id="Fill 1"
          d="M14.5715 13.5941L20.4266 7.72014C20.7929 7.35183 21 6.84877 21 6.32376V4.60099C21 3.52002 20.1423 3 19.0844 3H4.91556C3.85765 3 3 3.52002 3 4.60099V6.3547C3 6.85177 3.18462 7.33087 3.51772 7.69419L8.89711 13.5632C8.9987 13.674 9.14034 13.7368 9.28979 13.7378L14.1915 13.7518C14.3332 13.7528 14.4699 13.6969 14.5715 13.5941Z"
          fill="currentColor"
        />
        <path
          id="Fill 4"
          opacity="0.4"
          d="M9.05615 13.6857V20.2903C9.05615 20.5309 9.17728 20.7575 9.37557 20.8872C9.48889 20.9621 9.61978 21 9.75068 21C9.84934 21 9.948 20.979 10.0398 20.9371L14.0057 19.0886C14.2539 18.9738 14.4131 18.7213 14.4131 18.4428V13.6857H9.05615Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
